(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/marketplace-competition/services/assets/reducers/reducer.js') >= 0) return;  svs.modules.push('/components/marketplace-competition/services/assets/reducers/reducer.js');
"use strict";


const _RTK = RTK,
  combineReducers = _RTK.combineReducers;
const _svs$components$marke = svs.components.marketplaceCompetition.services.reducers,
  makePlayerCompetitionReducer = _svs$components$marke.makePlayerCompetitionReducer,
  makeCompetitionReducer = _svs$components$marke.makeCompetitionReducer,
  dialogReducer = _svs$components$marke.dialogReducer,
  competitionResultReducer = _svs$components$marke.competitionResultReducer,
  teamsReducer = _svs$components$marke.teamsReducer,
  createTeamReducer = _svs$components$marke.createTeamReducer,
  wagersReducer = _svs$components$marke.wagersReducer;
const FetchState = svs.components.marketplaceCompetition.constants.FetchState;
const normalizedCompetitionReducerState = {
  knownCompetitions: {},
  activeCompetitionId: undefined,
  participants: {}
};
const playerCompetitionInitialState = {
  signUps: {
    competitions: {},
    status: FetchState.Idle,
    lastFetch: null
  },
  draws: {}
};
const defaultArray = [];
const reducer = (preloadedCompetition, preloadedPlayerCompetitionDetails) => {
  if (preloadedCompetition) {
    normalizedCompetitionReducerState.knownCompetitions[preloadedCompetition.getCompetitionId()] = {
      data: preloadedCompetition.getSnapshot(),
      status: FetchState.Fulfilled,
      lastFetch: new Date().toISOString()
    };
  }
  const playerCompetitions = preloadedPlayerCompetitionDetails && Object.values(preloadedPlayerCompetitionDetails.playerCompetitions) || defaultArray;
  const playerCompetitionDraws = preloadedPlayerCompetitionDetails && Object.values(preloadedPlayerCompetitionDetails.playerCompetitionDraws) || defaultArray;
  if (playerCompetitions.length) {
    playerCompetitionInitialState.signUps.competitions = preloadedPlayerCompetitionDetails.playerCompetitions;
    playerCompetitionInitialState.signUps.status = FetchState.Fulfilled;
    playerCompetitionInitialState.signUps.lastFetch = new Date().toISOString();
  }
  if (playerCompetitionDraws.length) {
    const competitionIds = Object.keys(preloadedPlayerCompetitionDetails.playerCompetitionDraws);
    playerCompetitionDraws.forEach((compDraws, index) => {
      playerCompetitionInitialState.draws[competitionIds[index]] = {
        data: {
          draws: compDraws
        },
        status: FetchState.Fulfilled,
        lastFetch: new Date().toISOString()
      };
    });
  }
  return combineReducers({
    Competitions: makeCompetitionReducer(normalizedCompetitionReducerState),
    PlayerCompetitions: makePlayerCompetitionReducer(playerCompetitionInitialState),
    Teams: teamsReducer,
    Dialog: dialogReducer,
    CompetitionResult: competitionResultReducer,
    CreateTeam: createTeamReducer,
    Wagers: wagersReducer
  });
};
setGlobal('svs.components.marketplaceCompetition.services.reducers.reducer', reducer);

 })(window);